import React, { useRef } from "react";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { CloudArrowUp, Receipt, Paperclip } from "@phosphor-icons/react";
import AttachmentList from "./AttachmentList";

function UploadCard({
  title,
  description,
  items,
  kind,
  inputTestId,
  buttonTestId,
  onUpload,
  onDownload,
  onDelete,
}) {
  const ref = useRef(null);
  return (
    <div className="bg-white border border-slate-200 rounded-lg">
      <div className="px-6 py-4 border-b border-slate-200 flex items-center justify-between">
        <div>
          <h3 className="font-heading font-semibold text-slate-900">{title}</h3>
          <p className="text-xs text-slate-500 mt-0.5">{description}</p>
        </div>
        <input
          ref={ref}
          type="file"
          className="hidden"
          onChange={(e) => {
            const f = e.target.files?.[0];
            if (f) onUpload(f, kind);
            e.target.value = "";
          }}
          data-testid={inputTestId}
        />
        <button
          onClick={() => ref.current?.click()}
          data-testid={buttonTestId}
          className="inline-flex items-center gap-2 px-3 h-9 rounded-md bg-blue-600 text-white text-sm font-medium hover:bg-blue-700"
        >
          <CloudArrowUp size={16} /> Upload
        </button>
      </div>
      <AttachmentList
        items={items}
        onDownload={onDownload}
        onDelete={onDelete}
      />
    </div>
  );
}

export default function VendorAttachmentsTabs({
  generalFiles,
  invoices,
  onUpload,
  onDownload,
  onDelete,
}) {
  return (
    <Tabs defaultValue="general" className="w-full">
      <TabsList
        className="h-auto bg-white border border-slate-200 rounded-md p-1"
        data-testid="vendor-tabs"
      >
        <TabsTrigger value="general" data-testid="tab-general-files" className="px-4 py-2">
          <Paperclip size={14} className="mr-2" /> Documents ({generalFiles.length})
        </TabsTrigger>
        <TabsTrigger value="invoices" data-testid="tab-invoices" className="px-4 py-2">
          <Receipt size={14} className="mr-2" /> Invoices ({invoices.length})
        </TabsTrigger>
      </TabsList>

      <TabsContent value="general" className="mt-5">
        <UploadCard
          title="Documents"
          description="Warranty, AMC, Repair reports, contracts, etc."
          items={generalFiles}
          kind="general"
          inputTestId="vendor-general-file-input"
          buttonTestId="upload-vendor-general-button"
          onUpload={onUpload}
          onDownload={onDownload}
          onDelete={onDelete}
        />
      </TabsContent>

      <TabsContent value="invoices" className="mt-5">
        <UploadCard
          title="Invoices"
          description="Billing invoices and receipts."
          items={invoices}
          kind="invoice"
          inputTestId="vendor-invoice-file-input"
          buttonTestId="upload-vendor-invoice-button"
          onUpload={onUpload}
          onDownload={onDownload}
          onDelete={onDelete}
        />
      </TabsContent>
    </Tabs>
  );
}
